import React from "react";

interface SidebarContainerProps {
  isCollapsed: boolean;
  children: React.ReactNode;
}

export const SidebarContainer: React.FC<SidebarContainerProps> = ({ isCollapsed, children }) => {
  return (
    <div 
      className={`hidden md:block fixed top-0 bottom-0 z-20 bg-gradient-to-b from-[#181D24] to-[#1A2233] border-r border-[#222A35] shadow-xl transition-all duration-300 
        ${isCollapsed ? 'w-16' : 'w-64'}`}
    >
      <div className="h-full flex flex-col">
        {children}
      </div>
    </div>
  );
};
